import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Buildings16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_283)'>
      <path d='M13 5.75H9V4.25H13V5.75Z' fill='currentColor' />
      <path d='M13 8.75H9V7.25H13V8.75Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.25 1.5C6.25 0.809643 6.80964 0.25 7.5 0.25H14.5C15.1904 0.25 15.75 0.809644 15.75 1.5V14.5C15.75 15.1904 15.1904 15.75 14.5 15.75H1.5C0.809645 15.75 0.25 15.1904 0.25 14.5V7.5C0.25 6.80964 0.809644 6.25 1.5 6.25H6.25V1.5ZM6.25 7.75H1.75V14.25H6.25V7.75ZM7.75 14.25H10.25V12H11.75V14.25H14.25V1.75H7.75V14.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_283'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Buildings16.displayName = 'Buildings16';
export default Buildings16;
